var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 4.58182 13.4182 1 9 1C4.58182 1 1 4.58182 1 9C1 14.8182 9 22.8182 9 22.8182C9 22.8182 17 14.8182 17 9Z",
    stroke: "#8D8080",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.9091C10.6066 11.9091 11.9091 10.6066 11.9091 9C11.9091 7.39336 10.6066 6.09091 9 6.09091C7.39336 6.09091 6.09091 7.39336 6.09091 9C6.09091 10.6066 7.39336 11.9091 9 11.9091Z",
    stroke: "#8D8080",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.478265dcbbea566a2b80559deffec7de.svg";
export { ForwardRef as ReactComponent };